import * as React from 'react';

import ConnectAccountInformation from './connectAccountInformation';
import ConnectBillingAddress from './connectBillingAddress';
import CouponList from './couponList';

interface Props {
  userId: string;
}

const MemberDetailConnect = ({ userId }: Props) => {
  return (
    <>
      <ConnectAccountInformation userId={userId} />
      <ConnectBillingAddress userId={userId} />
      <CouponList userId={userId} />
    </>
  );
};

export default MemberDetailConnect;
